import _ from 'lodash';

export default function mutations() {
	return {
		setLoading: (state, payload) => {
			state.loading = payload;
		},
		setInputData: (state, { group, key, value, index }) => {
			if (group === 'real_estate' && key === 'floor_area' && !state.insuranceValueIsRandom) {
				state.real_estate.insurance_value = 630000 * value;
			}

			if (index === null) {
				state[group][key] = value;
			} else {
				state[group][index][key] = value;
			}
		},
		setEvent: (state, { id, temp = false }) => {
			const stateModel = temp ? state.temp : state;

			if (stateModel.insurance_events.includes(id)) {
				const index = stateModel.insurance_events.indexOf(id);
				stateModel.insurance_events.splice(index, 1);
			} else {
				stateModel.insurance_events.push(id);
			}
		},
		setEventInactive: (state, id) => {
			if (state.insurance_events.includes(id)) {
				const index = state.insurance_events.indexOf(id);
				state.insurance_events.splice(index, 1);
			}

			if (!state.inactive_events.includes(id)) {
				state.inactive_events.push(id);
			}
		},
		removeEventInactive: (state, id) => {
			if (state.inactive_events.includes(id)) {
				const index = state.inactive_events.indexOf(id);
				state.inactive_events.splice(index, 1);
			}
		},
		cloneEvents: state => {
			state.temp.insurance_events = _.cloneDeep(state.insurance_events);
		},
		setTempEvents: state => {
			state.insurance_events = _.cloneDeep(state.temp.insurance_events);
		},
		setInsuranceEvents: (state, payload) => {
			state.baseData.insurance_events = payload;
		},
		setPremiseTypes: (state, payload) => {
			state.baseData.premise_types = payload;
		},
		setOutbuildingTypes: (state, payload) => {
			state.baseData.outbuildingTypes = payload;
		},
		setOutbuildingLocations: (state, payload) => {
			state.baseData.outbuildingLocations = payload;
		},
		setMovableTypes: (state, payload) => {
			state.baseData.movable_types = payload;
		},
		setCurrentStep: (state, payload) => {
			state.currentStep = payload;
		},
		setSearchResult: (state, { type, data, group }) => {
			if (group !== null && group !== undefined) {
				if (!_.has(state.baseData.searchResult, group)) {
					_.assign(state.baseData.searchResult, { [group]: {} });
				}

				if (!_.has(state.baseData.searchResult[group], type)) {
					_.assign(state.baseData.searchResult[group], { [type]: [] });
				}

				state.baseData.searchResult[group][type] = data;
			} else {
				state.baseData.searchResult[type] = data;
			}
		},
		showPopup: (state, popup) => {
			state.popup = popup;
		},
		popupHasClose: (state, payload) => {
			state.popupHasClose = payload;
		},
		setRealEstateData: (state, payload) => {
            for (const [key, value] of Object.entries(payload)) {
                state.real_estate[key] = value;
            }
		},
		setCalculationData: (state, payload) => {
			state.calculation = payload;
		},
		setCategory: (state, category) => {
			state.category = category;
		},
		setOutbuildings: (state, payload) => {
			state.outbuildings = payload;
		},
		setBuildings: (state, payload) => {
			state.buildings = payload;
		},
		setPremises: (state, payload) => {
			state.premises = payload;
		},
        fixPremises: (state) => {
            state.premises = state.premises.map((premise)=>{
                if(typeof premise.label === 'undefined' || premise.label === null || typeof premise.multipler === 'undefined' || premise.multipler === null) {
                    let premise_type = state.baseData.premise_types.find(type => type.id === premise.type_id);
                    premise.label = premise_type.name;
                    premise.multipler = premise_type.multipler;
                }
                return premise;
            });
        },
		setMovables: (state, payload) => {
			state.movables = payload;
		},
		setValuables: (state, payload) => {
			state.valuables = payload;
		},
		newOutbuilding: state => {
			if (state.outbuildings.length < 5) {
				state.outbuildings.push({
					floor_area: null,
					roof_type: null,
					wall_type: null,
					insurance_value: null,
					movable_value: null,
					type_id: null,
					location_id: null,
				});
			}
		},
		deleteOutbuilding: (state, index) => {
			state.outbuildings.splice(index, 1);
		},
		newBuilding: state => {
			if (state.buildings.length < 5) {
				state.buildings.push({
					type: null,
					insurance_value: null,
				});
			}
		},
		deleteBuilding: (state, index) => {
			state.buildings.splice(index, 1);
		},
		newPremise: (state, payload) => {
			state.premises.push(payload);
		},
		deletePremise: (state, type_id) => {
			const index = state.premises.findIndex(premise => premise.type_id === type_id);
			state.premises.splice(index, 1);
		},
        clearPremises: (state) => {
            state.premises.length = 0;
        },
		createMovablesByTypes: state => {
			if (state.movables.length === 0 || state.valuables.length === 0) {
				let movableArray = [];
				let valuableArray = [];

				state.baseData.movable_types.movables.forEach(movable => {
					const value = state.movables.find(hasMovable => hasMovable.type_id === movable.id);
					movableArray.push({
						...movable,
						type_id: movable.id,
						insurance_value: value === undefined ? null : value.insurance_value,
					});
				});

				state.baseData.movable_types.valuables.forEach(valuable => {
					const value = state.valuables.find(hasValuable => hasValuable.type_id === valuable.id);
					valuableArray.push({
						...valuable,
						type_id: valuable.id,
						insurance_value: value === undefined ? null : value.insurance_value,
					});
				});

				state.movables = movableArray;
				state.valuables = valuableArray;
			}
		},
		setOffers: (state, payload) => {
			state.offers = payload;
		},
		clearOffers: state => {
			state.offers = null;
		},
		setSelectedOffer: (state, payload) => {
			if (state.selectedOffers.includes(payload)) {
				const index = state.selectedOffers.indexOf(payload);
				state.selectedOffers.splice(index, 1);
			} else {
				state.selectedOffers.push(payload);
			}
		},
		clearSelectedOffers: state => {
			state.selectedOffers = [];
		},
		setMobileMenu: (state, payload) => {
			state.mobile_menu = payload;
		},
		setRealEstates: (state, payload) => {
			state.real_estates = payload;
		},
		setSelectedUser: (state, payload) => {
			state.selectedUser = payload;
		},
		setWsErrors: (state, payload) => {
			state.wsErrors = payload;
		},
		setStateData: (state, { prop, value }) => {
			state[prop] = value;
		},
		toggleInsuranceValue: state => {
			if (state.insuranceValueIsRandom) {
				state.real_estate.insurance_value = null;
			} else {
				if (state.real_estate.insurance_value === null) {
					state.real_estate.insurance_value = state.real_estate.floor_area * 630000;
				}
			}
		},
		toggleParcelNumber: state => {
			if (state.hasParcelNumber) {
				state.real_estate.house_number = null;
			} else {
				state.real_estate.parcel_number = null;
			}
		},
		setError: (state, payload) => {
			state.error = payload;
		},
		setMakeNotify: (state, payload) => {
			state.makeNotify = payload;
		},
        setIsBusinessProcess:
            (state, payload) => {
                state.is_business_process = !!payload;
        },
        setBikaRealEstate: (state, payload) => {
                state.bikaRealEstate = payload;
        },
        setLoadedAddress: (state, payload) => {
            state.loadedAddress = payload;
        },
        setLoadingBikaId: (state, payload) => {
            state.loadingBikaId = payload;
        },
        setMatchingRealEstateUsers: (state, payload) => {
            state.matchingRealEstateUsers = payload;
        },
        setOtherConsultantName: (state, payload) => {
            state.otherConsultantName = payload;
        },
        setBikaImportInvalidEmail: (state, payload) => {
            state.bikaImportInvalidEmail = payload;
        },
        setOldContractLastStep: (state, payload) => {
            state.questionAnswers.oldContractLastStep = payload;
        },
        clearCalculationStart_of_risk: (state) => {
            state.calculation.start_of_risk = null;
        },
        setIsCampaignCalculation: (state, payload) => {
                state.is_campaign_calculation = payload;
        },
        setCalculationStart_of_risk: (state, payload) => {
            state.calculation.start_of_risk = payload;
        },
        setQuestionAnswers: (state, payload) => {
                state.questionAnswers.isNewContract = payload.isNewContract;
                state.questionAnswers.isMfo = payload.isMfo;
                state.questionAnswers.startOfRisk = payload.startOfRisk;
                state.questionAnswers.bondNumber = payload.bondNumber;
                state.questionAnswers.insurer = payload.insurer;
                state.questionAnswers.twoYear = payload.twoYear;
                state.questionAnswers.oldContractLastStep = payload.oldContractLastStep;
                state.questionAnswers.hasCondominiumInsurance = payload.hasCondominiumInsurance;
                state.questionAnswers.condominiumInsurer = payload.condominiumInsurer;
        }
	};
}
